import React, { Component } from 'react';
import { storage } from '../../config/firebaseConfig';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';

class FutureElevation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            imgUrl: "",
            showModal: false,
        }
    }

    componentDidMount() {
        const { elevationMap } = this.props;
        const { proid, fileName } = elevationMap;

        if (proid !== "" || fileName !== "") {
            // Create a reference to the file we want to download
            var floorRef = storage.ref(`/Projects/${proid}/elevations/${fileName}.png`);

            // Get the download URL
            floorRef.getDownloadURL().then(url => {
                // console.log(url)
                this.setState({ imgUrl: url });
            }).catch(e => {

            })
        }
    }

    handleOpenModal = () => {
        this.setState({ showModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    render() {
        const { imgUrl } = this.state;
        const { modalStyles, styleClass, height, isCirclePreview, elevationMap } = this.props;
        const { fileName } = elevationMap;

        var dynamicLink = imgUrl.length > 0 ? isCirclePreview ?
            (<span role="button" onClick={this.handleOpenModal}>
                <img src={imgUrl} className={styleClass} alt="" title="See preview map" height={height} />
            </span>)
            :
            (<span role="button" data-toggle="tooltip" data-placement="top" title={fileName} style={{ fontSize: "12px", fontStyle: "italic", color: "GrayText" }} onClick={this.handleOpenModal}>(preview)</span>)
            : (<React.Fragment>Loading...</React.Fragment>);

        return (
            <React.Fragment>
                {/* NORMAL PREVIEW IMAGE */}
                {dynamicLink}

                {/* MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showModal}
                    onRequestClose={this.handleCloseModal}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <img src={imgUrl} alt="map" title="preview map" height="500px" />
                    <button className="close" onClick={this.handleCloseModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </ReactModal>
            </React.Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        modalStyles: state.appControl.modalStyles,
    }
}

export default connect(mapStateToProps)(FutureElevation);
